import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useUpdateOperationChainItem,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useUpdateOperationChainItemMutation = () =>
  useUpdateOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findOperationChainItemsQueryKey(
            variables.data.operationChainId
          ),
        })
        showSuccessNotification({
          title: "Success",
          message: "Operation chain item updated",
        })
      },
      onError: (error) => {
        showAxiosError({
          error,
          notificationTitle: "Failed to update operation chain item",
          showNotification: true,
        })
      },
    },
  })
